import React, { useState } from 'react';
import './YieldOverlay.scss'
import { useSelector, useDispatch } from 'react-redux';
import { selectYieldStatus } from '../../../redux/overlaySlice';
import { selectPlayers, selectPlayerAtCityCenter, selectPlayerAtLake, selectMyPlayer, answerYield } from '../../../redux/gameSlice';
import { useEffect } from 'react';
import { monsterClassFromId } from '../../../monsters';
import { Trans, t } from '@lingui/macro';
import i18n from '../../../i18n';

export default function YieldOverlay() {
  const dispatch = useDispatch();
  const players = useSelector(selectPlayers);
  const myPlayer = useSelector(selectMyPlayer);
  const yieldStatus = useSelector(selectYieldStatus);
  const playerIdAtCityCenter = useSelector(selectPlayerAtCityCenter);
  const playerIdAtLake = useSelector(selectPlayerAtLake);
  const [timeLeft, setTimeLeft] = useState(yieldStatus.duration);
  const playerChoosingToStayOrLeaveTown = (
    (myPlayer.id === playerIdAtLake && !yieldStatus.answered.lake)
    || (myPlayer.id === playerIdAtCityCenter && !yieldStatus.answered.cityCenter)
  );
  const ropeWidth = `${Math.max(0, Math.floor(timeLeft / yieldStatus.duration * 100))}%`;

  useEffect(() => {
    if (Math.ceil(timeLeft) < -1 && playerChoosingToStayOrLeaveTown) {
      dispatch(answerYield(true));
      return;
    }

    // Trigger a timeout once, then that'll trigger this useEffect, which will set a new timer again :)
    let timeoutHandler = setTimeout(() => setTimeLeft(yieldStatus.end - Date.now()), 1000);
    return () => clearTimeout(timeoutHandler);
  }, [timeLeft, dispatch, yieldStatus.end, playerChoosingToStayOrLeaveTown]);

  let content = "";
  if (playerChoosingToStayOrLeaveTown) {
    content = <>
      <div id="yielding-decision-monsters">
        <div className={`game-sprite yielding-decision-monster-image ${monsterClassFromId(myPlayer.monster_id)}`}></div>
      </div>
      <p id="yielding-decision-text">
        <Trans>
          You are currently in the town and have just been attacked.
          <br />
          Do you want to remain here or escape right away?
        </Trans>
      </p>
      <div id="yielding-decision-action-buttons">
        <button className="button" onClick={() => dispatch(answerYield(false))}><Trans>REMAIN IN TOWN</Trans></button>
        <button className="button" onClick={() => dispatch(answerYield(true))}><Trans>ESCAPE TOWN</Trans></button>
      </div>
    </>;
  }
  else {
    let playerList = [];
    let monstersInTown = [];
    if (playerIdAtCityCenter && !yieldStatus.answered.cityCenter) {
      const playerAtCityCenter = players.find((player) => player.id === playerIdAtCityCenter);
      monstersInTown.push(<div key="monster-deciding-downtown" className={`game-sprite yielding-decision-monster-image ${monsterClassFromId(playerAtCityCenter.monster_id)}`}></div>);
      playerList.push(playerAtCityCenter.name);
    }

    if (playerIdAtLake && !yieldStatus.answered.lake) {
      const playerAtLake = players.find((player) => player.id === playerIdAtLake);
      playerList.push(playerAtLake.name);
      monstersInTown.push(<div key="monster-deciding-lake" className={`game-sprite yielding-decision-monster-image ${monsterClassFromId(playerAtLake.monster_id)}`}></div>);
    }

    const stakeholderSpan = (name) => <span className="yielding-decision-stakeholder">{name} </span>;
    content = <>
      <div id="yielding-decision-monsters">{monstersInTown}</div>
      <p id="yielding-decision-text">
        <Trans>
          Currently waiting for {stakeholderSpan(playerList[0])} {playerList.length > 1
            ? <>{i18n._(t`and`)} {stakeholderSpan(playerList[1])}</>
            : null
          } to decide whether or not to remain in town, after having been damaged
        </Trans>
      </p>
    </>;
  }

  return <div id="yielding-decision-overlay" className="overlay-background">
    <div id="yielding-decision-overlay-container">
      {content}

      <div id="countdown-container">
        <div id="countdown-rope-wrap">
          <div id="countdown-rope" style={{ maxWidth: ropeWidth }}></div>
        </div>
      </div>
    </div>
  </div>;
}
